<div class="legend">
    <span *ngIf="textInit">{{ textInit }}</span>
    <div class="color" *ngFor="let i of items">
        <div class="icon" [style.background-color]="i.color"></div>
        <div class="description">{{ i.description }}</div>
    </div>
</div>